export const HOME_GALLERY_EDIT_ACTION = {
  CANVA: "canva",
  IA: "ia",
  ANIMATE: "animate",
  RESIZE: "resize",
};
